require '../transforms/array-of-objects'

###
# Модель канала коммуникации
###
App.CommunicationChannel = DS.Model.extend
  priority: DS.attr 'number'
  kind:     DS.attr 'string'
  enabled:  DS.attr 'boolean'
  name:     DS.attr 'string'
  status_message:        DS.attr 'string'
  can_send_chat_message: DS.attr 'boolean'

  #Внешние связи
  restaurants:       DS.hasMany 'restaurant', async: true

  formattedText: (->
    @get('name') or Em.I18n.t "communication_channels.kinds.#{@get('kind')}"
  ).property('kind', 'name')

  status: (->
    return 'error' if @get('status_message') 
    return if @get('enabled') then 'enabled' else 'disabled'
  ).property('enabled', 'status_message')

  hasError: Em.computed.equal('status', 'error')

  isWatsapp: Em.computed.equal('kind', 'whatsapp')

  needAuth: (->
    @get('isWatsapp') and @get('status_message')
  ).property('isWatsapp', 'status_message')

  statusText: (->
    Em.I18n.t "communication_channels.status.#{@get('status')}"
  ).property('status')

  isAuthLoading: false

  getAuthLink: ->
    @nonRESTAction('GET', 'auth_link')
